import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _slicedToArray from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _classCallCheck from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module remove-format/removeformatcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import first from '@ckeditor/ckeditor5-utils/src/first';
/**
 * The remove format command.
 *
 * It is used by the {@link module:remove-format/removeformat~RemoveFormat remove format feature}
 * to clear the formatting in the selection.
 *
 *		editor.execute( 'removeFormat' );
 *
 * @extends module:core/command~Command
 */

var RemoveFormatCommand = /*#__PURE__*/function (_Command) {
  _inherits(RemoveFormatCommand, _Command);

  var _super = _createSuper(RemoveFormatCommand);

  function RemoveFormatCommand() {
    _classCallCheck(this, RemoveFormatCommand);

    return _super.apply(this, arguments);
  }

  _createClass(RemoveFormatCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var model = this.editor.model;
      this.isEnabled = !!first(this._getFormattingItems(model.document.selection, model.schema));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this = this;

      var model = this.editor.model;
      var schema = model.schema;
      model.change(function (writer) {
        var _iterator = _createForOfIteratorHelper(_this._getFormattingItems(model.document.selection, schema)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.is('selection')) {
              var _iterator2 = _createForOfIteratorHelper(_this._getFormattingAttributes(item, schema)),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var attributeName = _step2.value;
                  writer.removeSelectionAttribute(attributeName);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } else {
              // Workaround for items with multiple removable attributes. See
              // https://github.com/ckeditor/ckeditor5-remove-format/pull/1#pullrequestreview-220515609
              var itemRange = writer.createRangeOn(item);

              var _iterator3 = _createForOfIteratorHelper(_this._getFormattingAttributes(item, schema)),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _attributeName = _step3.value;
                  writer.removeAttribute(_attributeName, itemRange);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
    /**
     * Returns an iterable of items in a selection (including the selection itself) that have formatting model
     * attributes to be removed by the feature.
     *
     * @protected
     * @param {module:engine/model/documentselection~DocumentSelection} selection
     * @param {module:engine/model/schema~Schema} schema The schema describing the item.
     * @returns {Iterable.<module:engine/model/item~Item>|Iterable.<module:engine/model/documentselection~DocumentSelection>}
     */

  }, {
    key: "_getFormattingItems",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function _getFormattingItems(selection, schema) {
      var _this2 = this;

      var itemHasRemovableFormatting, _iterator4, _step4, curRange, _iterator5, _step5, item;

      return regeneratorRuntime.wrap(function _getFormattingItems$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              itemHasRemovableFormatting = function itemHasRemovableFormatting(item) {
                return !!first(_this2._getFormattingAttributes(item, schema));
              };

              _iterator4 = _createForOfIteratorHelper(selection.getRanges());
              _context.prev = 2;

              _iterator4.s();

            case 4:
              if ((_step4 = _iterator4.n()).done) {
                _context.next = 26;
                break;
              }

              curRange = _step4.value;
              _iterator5 = _createForOfIteratorHelper(curRange.getItems());
              _context.prev = 7;

              _iterator5.s();

            case 9:
              if ((_step5 = _iterator5.n()).done) {
                _context.next = 16;
                break;
              }

              item = _step5.value;

              if (!itemHasRemovableFormatting(item)) {
                _context.next = 14;
                break;
              }

              _context.next = 14;
              return item;

            case 14:
              _context.next = 9;
              break;

            case 16:
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](7);

              _iterator5.e(_context.t0);

            case 21:
              _context.prev = 21;

              _iterator5.f();

              return _context.finish(21);

            case 24:
              _context.next = 4;
              break;

            case 26:
              _context.next = 31;
              break;

            case 28:
              _context.prev = 28;
              _context.t1 = _context["catch"](2);

              _iterator4.e(_context.t1);

            case 31:
              _context.prev = 31;

              _iterator4.f();

              return _context.finish(31);

            case 34:
              if (!itemHasRemovableFormatting(selection)) {
                _context.next = 37;
                break;
              }

              _context.next = 37;
              return selection;

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _getFormattingItems, null, [[2, 28, 31, 34], [7, 18, 21, 24]]);
    })
    /**
     * Returns an iterable of formatting attributes of a given model item.
     *
     * **Note:** Formatting items have the `isFormatting` property set to `true`.
     *
     * @protected
     * @param {module:engine/model/item~Item|module:engine/model/documentselection~DocumentSelection} item
     * @param {module:engine/model/schema~Schema} schema The schema describing the item.
     * @returns {Iterable.<String>} The names of formatting attributes found in a given item.
     */

  }, {
    key: "_getFormattingAttributes",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function _getFormattingAttributes(item, schema) {
      var _iterator6, _step6, _step6$value, attributeName, attributeProperties;

      return regeneratorRuntime.wrap(function _getFormattingAttributes$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(item.getAttributes());
              _context2.prev = 1;

              _iterator6.s();

            case 3:
              if ((_step6 = _iterator6.n()).done) {
                _context2.next = 11;
                break;
              }

              _step6$value = _slicedToArray(_step6.value, 1), attributeName = _step6$value[0];
              attributeProperties = schema.getAttributeProperties(attributeName);

              if (!(attributeProperties && attributeProperties.isFormatting)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 9;
              return attributeName;

            case 9:
              _context2.next = 3;
              break;

            case 11:
              _context2.next = 16;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](1);

              _iterator6.e(_context2.t0);

            case 16:
              _context2.prev = 16;

              _iterator6.f();

              return _context2.finish(16);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _getFormattingAttributes, null, [[1, 13, 16, 19]]);
    })
  }]);

  return RemoveFormatCommand;
}(Command);

export { RemoveFormatCommand as default };